export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SigninView.vue?vue&type=template&id=5b80b8be&"


//////////////////
// WEBPACK FOOTER
// ./src/views/SigninView.vue?vue&type=template&id=5b80b8be&
// module id = 529
// module chunks = 7